import Route from '@ember/routing/route';

export default class AppManageSubscriptionsRoute extends Route {}
